import { APIIntegration } from "@integrations/APIIntegration";
import { Logger } from "@utils/Logger";
import { UsersService } from "@services/UsersService";
import { CommunicationsService } from "@services/CommunicationsService";
import { ShiftsService } from "@services/ShiftsService";
import { DashboardService } from "@services/DashboardService";
import { MetabaseService } from "@services/MetabaseService";
import { AlertsService } from "@services/AlertasService";
import { NotificationsService } from "@services/NotificationsService";
import { NovedadesService } from "@services/NovedadesService";
import { LeaveAbsenseService } from "@services/LeaveAbsenseService";
import { QontactPointsService } from "@services/QontactPointsService";
import { RolesService } from "@services/RolesService";
import { Analytics } from "./Analytics/Analytics";
import { AlgoliaService } from "@services/AlgoliaService";
import { AuditService } from "@services/AuditService";
import { QuestionsService } from "@services/QuestionsService";
import HourBankService from "@services/HourBankService";
import HourBankCompensationService from "@services/HourBankCompensationService";
import { UserDedicatedShiftsService } from "@services/UserDedicatedShiftsService";
import { HTTPClientInterface } from "@shared/core/HTTPClientInterface";
import { HTTPClient } from "@shared/core/HTTPClient";

export class CoreDependencies {
    _httpClient: HTTPClientInterface;
    readonly analytics: Analytics

    usersService: UsersService
    communicationsService: CommunicationsService
    shiftsService: ShiftsService
    dashboardService: DashboardService
    metabaseService: MetabaseService
    alertsService: AlertsService
    notificationsService: NotificationsService
    novedadesService: NovedadesService
    leaveAbsenseService: LeaveAbsenseService
    qontactPointsService: QontactPointsService
    rolesService: RolesService
    algoliaService: AlgoliaService
    auditService: AuditService
    questionsService: QuestionsService
    hourBankService: HourBankService
    hourBankCompensationService: HourBankCompensationService
    userDedicatedShiftsService: UserDedicatedShiftsService

    constructor(httpClient: HTTPClient) {
        this._httpClient = httpClient;
        this.analytics = new Analytics(httpClient)   
        this.usersService = new UsersService(this.httpClient);
        this.communicationsService = new CommunicationsService(this.httpClient);
        this.shiftsService = new ShiftsService(this.httpClient);
        this.dashboardService = new DashboardService(this.httpClient);
        this.metabaseService = new MetabaseService(this.httpClient);
        this.alertsService = new AlertsService(this.httpClient);
        this.notificationsService = new NotificationsService(this.httpClient);
        this.novedadesService = new NovedadesService(this.httpClient);
        this.leaveAbsenseService = new LeaveAbsenseService(this.httpClient);
        this.qontactPointsService = new QontactPointsService(this.httpClient);
        this.rolesService = new RolesService(this.httpClient);
        this.algoliaService = new AlgoliaService(this.httpClient);
        this.auditService = new AuditService(this.httpClient);
        this.questionsService = new QuestionsService(this.httpClient);
        this.hourBankService = new HourBankService(this.httpClient)
        this.hourBankCompensationService = new HourBankCompensationService(this.httpClient)
        this.userDedicatedShiftsService = new UserDedicatedShiftsService(this.httpClient)
    }

    public get httpClient(): HTTPClientInterface {
        // this._httpClient.commonHeaders = {
        //     "Content-Type": "application/json",
        //     "x-access-token": APIIntegration.apiToken
        // }
        // Logger.log("coreDependencies","headers")
        // Logger.logObject("headers", this._httpClient.commonHeaders)
        return this._httpClient;
    }
}
